import { DeskPageHeaderComponents, ButtonType, StyledPropsTheme } from '@my-types';
import { React, Styled } from '@common/3rd';
import { Envs, PATH, Storage, Ajax, Utils } from '@common';
import { PageHeader } from '@component';
import { DeskButton, DeskImage } from '@desk-component';
import { StyledComponents } from '@styles';
import Dialog from '@dialog';
import { mejLogo, mejLogoLight, defaultNickname, defaultAvatar } from '../../const';

/**
 * 桌面页眉
 */
class DeskPageHeader<
	P,
	S,
	C extends DeskPageHeaderComponents
	> extends PageHeader<P, S & any, C> {
	constructor(props: any) {
		super(props);
		this.state = {
			showNav: false
		};
	}
	protected initComponents(): C {
		return Object.assign(super.initComponents(), {
			Box: Styled.div.attrs({
				'data-widget': 'desk-page-header'
			})`
				display: flex;
				justify-content: space-between;
				position: relative;
				width: 100vw;
				background: rgb(68, 86, 96);
				padding-left: calc(50vw - 555px);
				padding-right: calc(50vw - 555px);
				border-width: 1px;
				border-style: solid;
				color: ${props => props.theme.COLOR_REVERSED};
				height: 48px; // ${props => props.theme.DESK_PAGE_HEADER_HEIGHT}px;
				z-index: ${props => props.theme.PAGE_HEADER_Z_INDEX};
				&.no-menus {
					display: none;
				}
				.logo {
					background-image: url('${mejLogo}');
					background-size: contain;
				}
				&.light {
					background: #fff;
					.logo {
						background-image: url('${mejLogoLight}');
						background-size: contain;
					}
					.nav {
						> span {
							color: ${props => props.theme.FONT_COLOR};
							.fa-caret-down {
								color: ${props => props.theme.COLOR_SUCCESS};
							}
						}
					}
				}
				&:after {
					content: '';
					display: block;
					position: absolute;
					bottom: -1px;
					height: 1px;
					left: calc(50vw - 555px);
					right: calc(50vw - 555px);
					background: #eee;
				}
				${(props: any) => {
					if (Storage.Share.getThirdDeskHome()) {
						return `opacity: 0;
								display:none;`
					} else {
						return ``;
					}
				}}
			`,
			Logo: Styled.div.attrs({
				'data-widget': 'desk-page-header-logo'
			})`
				display: flex;
				align-items: center;
				.logo {
					cursor: pointer;
					width: 120px;
					height: 100%;
					background-repeat: no-repeat;
					background-position: left center;
					&.light {
						width: 180px;
					}
				}
				.ent-logo {
					cursor: pointer;
					display: flex;
					align-items: center;
					width: 120px;
					height: 40px;
					margin-left: 5px;
					img {
						height: 100%;
					}
				}
			`,
			Right: Styled.div.attrs({
				'data-widget': 'desk-page-header-right'
			})`
				flex: 1;
				justify-content: flex-end;
				display: flex;
				> * {
					position:absolute;
					&[data-widget="desk-btn"] {
						top:50%;
						transform:translateY(-50%);
						height: 34px;
						line-height: 24px;
						min-width: 60px;
					}
				}
				.nav {
					> span {
						cursor: pointer;
					}
					position: relative;
					line-height: 48px;
					font-weight: ${props => props.theme.FONT_WEIGHT_BOLD_LIGHT};
					.avatar-wrapper {
						display: inline-block;
						width: 35px;
						height: 35px;
						border-radius: 35px;
						overflow: hidden;
						vertical-align: middle;
						position: relative;
						img {
							width: 100%;
							height: 100%;
							transform: translateY(-50%);
							top: 50%;
							position: absolute;
						}
					}
					> div {
						min-width: 120px;
						position: absolute;
						transition: all 1s ease;
						right: 0;
						text-align: center;
						display: block;
						visibility: visible;
						opacity: 1;
						top: 50px;
						background: #fff;
						color: #333;
						border-radius: 10px;
						overflow: hidden;
						box-shadow: 0px 3px 6px #ddd;
						> div {
							cursor: pointer;
							padding: 0 10px;
							line-height: 40px;
							border-bottom: 1px solid ${props => props.theme.BORDER_COLOR_LIGHT};
							&:hover {
								background: ${props => props.theme.COLOR_SUCCESS};
								color: #fff;
							}
						}
					}
				}
			`
		});
	}
	protected logout() {
		let dialogRef = Dialog.show('提示', <div>
			<p style={{textAlign: 'center'}}>请选择是否退出？</p>
			<div style={{display: 'flex', 'justifyContent': 'center', marginTop: '40px'}}>
				<DeskButton type={ButtonType.DEFAULT} css={() => `
					margin-right: 20px;
					flex: 1;`} onClick={() => {
					Dialog.hide(dialogRef);
				}}>取消</DeskButton>
				<DeskButton type={ButtonType.PRIMARY} css={(theme: StyledPropsTheme) => `
					border: 1px solid #eee;
					color: ${theme.COLOR_PRIMARY};
					flex: 1;
					&:hover {background: #db4b40;}
				`} onClick={async() => {
					Dialog.hide(dialogRef);
					await this.getHelpers().getAjax().post('/rest/v2/auth/signout',null);
					let url = process.env.REACT_APP_AJAX_CLIENT_CONTEXT + PATH.DESK2_HOME;
					let organQuery = Storage.Last.session().get('organQuery');
					if (organQuery?.originVendor) {
						url += encodeURIComponent(organQuery?.originVendor);
					}
					Storage.clear();
					Storage.Last.session().clear()
					window.location.href = url;
				}}>确认</DeskButton>
			</div>
		</div>, null, {
			boxCSS: {width: '400px', top: '30vh', padding: '40px'},
			closeBtn: true
		});
	}

	private convertOmitName(name: string){
        const nameCharList = name.split('');
        let newName= "";
        let countChinese = 0;
        for(let i=0;i<nameCharList.length;i++){
            newName = newName + nameCharList[i];
            if(new RegExp("^[\u2E80-\uFE4F]{1}$").test(nameCharList[i])){
                countChinese=countChinese +1;
            }
            if(countChinese >=4 && newName.length < name.length){
                return newName+'...';
            }
        }
        return name;
	}
	
	render() {
		let organInSession = Storage.Last.session().get('organ');
		const C = this.getComponents();
		const hideHeaderAndFooter = Envs.isPhone() && ['disclosure/agreement', 'disclosure/statement', 'disclosure/cookie'].some((path: string) => window.location.href.includes(path));
		return hideHeaderAndFooter ? <></> : (
			<C.Box className={!/sign|reset-pwd/.test(window.location.href) && (!organInSession || organInSession?.colorTheme === '2') ? 'light' : ''}>
				<C.Logo onClick={() => {
					let organQuery = Storage.Last.session().get('organQuery');
					let redirectPath = organQuery?.originVendor ? `${PATH.DESK2_HOME_VENDOR.replace(':vendor', encodeURIComponent(organQuery.originVendor))}` : PATH.DESK2_HOME;
					this.getHelpers().getRouter().pushRedirect(redirectPath);
				}}>
					<div className="logo"></div>
					{/* <img src={mejLogo} alt="logo" /> */}
					{organInSession?.logo ? <div className="ent-logo">
						<img src={organInSession.logo} alt="entlogo" />
					</div> : null}
				</C.Logo>
				<C.Right>
					{/* 未登录状态下登录/注册/重置密码不显示右侧菜单栏 */}
					{!window.location.href.includes(PATH.DESK2_SIGN) && !window.location.href.includes(PATH.DESK2_RESET_PASSWORD) ? (
						!Ajax.isAuthorized() ?
						<DeskButton type={ButtonType.PRIMARY} onClick={() => {
							let organQuery = Storage.Last.session().get('organQuery');
        					let redirectPath = organQuery?.originVendor ? `${PATH.DESK2_SIGN_IN_VENDOR.replace(':vendor', encodeURIComponent(organQuery.originVendor))}` : PATH.DESK2_SIGN_IN;
							this.getHelpers().getRouter().pushRedirect(redirectPath);
						}}>登录</DeskButton> : <div className="nav">
							<span style={{
								    display: 'flex',
									alignItems: 'center'
							}} onClick={() => {
								this.setState({
									showNav: !this.state.showNav
								});
							}}>
								{Envs.findAccount().avatar ? <span className="avatar-wrapper"><img src={Envs.findAccount().avatar} alt="avatar" /></span> :
								<DeskImage src={defaultAvatar} css={() => `width: 30px;vertical-align:middle;`} />}&nbsp;
								<span  style={{
									maxWidth: '100px',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap'
								}}>
									{this.convertOmitName(Envs.findAccount().nickname || '未设置')}
								</span>
								<StyledComponents.FAS icon="caret-down" />
							</span>
							{this.state.showNav ? <div>
								{/* <div onClick={() => {
									this.getHelpers().getRouter().pushRedirect(PATH.DESK2_PERSONAL_POLICY);
								}}>我的保单</div> */}
								<div onClick={() => {
									let organQuery = Storage.Last.session().get('organQuery');
									let redirectPath = organQuery?.originVendor ? `${PATH.DESK2_PERSONAL_POLICY_VENDOR.replace(':vendor', encodeURIComponent(organQuery.originVendor))}` : PATH.DESK2_PERSONAL_POLICY;
									this.getHelpers().getRouter().pushRedirect(redirectPath);
								}}>个人中心</div>
								<div onClick={() => {
									this.logout()
								}}>退出登录</div>
							</div> : null}
						</div>
					): null}
				</C.Right>
			</C.Box>
		);
	}
}

export default DeskPageHeader;
